window.locales = window.locales || {};window.locales.am = window.locales.am || {};window.locales.am.offlineBox = window.locales.am.offlineBox || {};window.locales.am.offlineBox = {...window.locales.am.offlineBox, ...{
    "headerSubtitle": "አንተ ነህ",
    "headerTitle": "ከመስመር ውጭ",
    "description": "ቀጥሉበት! የበይነመረብ ግንኙነትን ስናገኝ ሂደትዎን እናመሳስላለን።",
    "mobileHeader": "ከመስመር ውጭ ነዎት"
}
};window.locales.ar = window.locales.ar || {};window.locales.ar.offlineBox = window.locales.ar.offlineBox || {};window.locales.ar.offlineBox = {...window.locales.ar.offlineBox, ...{
    "headerSubtitle": "أنت",
    "headerTitle": "غير متصل",
    "description": "استمر! سنُزامن تقدمك عند اكتشاف اتصال بالإنترنت.",
    "mobileHeader": "أنت غير متصل"
}
};window.locales.en = window.locales.en || {};window.locales.en.offlineBox = window.locales.en.offlineBox || {};window.locales.en.offlineBox = {...window.locales.en.offlineBox, ...{
    "headerSubtitle": "You are",
    "headerTitle": "Offline",
    "description": "Keep going! We will sync your progress when we detect an internet connection.",
    "mobileHeader": "You are Offline"
}
};window.locales.es = window.locales.es || {};window.locales.es.offlineBox = window.locales.es.offlineBox || {};window.locales.es.offlineBox = {...window.locales.es.offlineBox, ...{
    "headerSubtitle": "Eres",
    "headerTitle": "Desconectado",
    "description": "¡Sigue! Sincronizaremos tu progreso cuando detectemos conexión a internet.",
    "mobileHeader": "Estás desconectado"
}
};window.locales.it = window.locales.it || {};window.locales.it.offlineBox = window.locales.it.offlineBox || {};window.locales.it.offlineBox = {...window.locales.it.offlineBox, ...{
    "headerSubtitle": "Sei",
    "headerTitle": "Fuori linea",
    "description": "Continua così! Sincronizzeremo i tuoi progressi non appena rileveremo una connessione internet.",
    "mobileHeader": "Sei offline"
}
};window.locales.zh = window.locales.zh || {};window.locales.zh.offlineBox = window.locales.zh.offlineBox || {};window.locales.zh.offlineBox = {...window.locales.zh.offlineBox, ...{
    "headerSubtitle": "你是",
    "headerTitle": "离线",
    "description": "继续！当我们检测到互联网连接时，我们会同步你的进度。",
    "mobileHeader": "您当前离线"
}
};